import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { PageHeader } from '../common'
import { QuestSession, QuestIntentionInsight } from './'

const QuestAllIntention = () => {
  const history = useHistory()
  const { questId } = useParams()

  return (
    <>
      <Helmet>
        <title>{'Intention & Insight | Abroad'}</title>
        <meta name='title' content={'Intention & Insight | Abroad'}></meta>
        <meta
          property='og:title'
          content={'Intention & Insight | Abroad'}></meta>
        <meta
          property='twitter:title'
          content={'Intention & Insight| Abroad'}></meta>
        <link
          rel='canonical'
          href={`${process.env.REACT_APP_DOMAIN}/quests`}></link>
        <meta
          property='og:url'
          content={`${process.env.REACT_APP_DOMAIN}/quests`}></meta>
        <meta
          property='twitter:url'
          content={`${process.env.REACT_APP_DOMAIN}/quests`}></meta>
      </Helmet>
      <div>
        <PageHeader
          showBackArrow={true}
          version='small'
          title='Your Experiences'
          backArrowAction={() => history.goBack()}
        />
        <h1 className='s1 py-16px'>Intentions & Insights</h1>
        <QuestSession />

        <QuestIntentionInsight questId={questId} />
      </div>
    </>
  )
}

export default QuestAllIntention
